import {config} from '../Config';

import {BaseSearchableService} from "./Core/BaseSearchableService";

class PermitService extends BaseSearchableService {
    get Url() { return super.Url + "/permits"; }
    get ModelName() { return "Permit"; }
    get PrimaryKeyProperty() { return "permitId"; }
    get TitleProperty() { return "permitNumber"; }
    get Request() {
        const organizationId = config.getStore().getState().contextState?.organizationId;

        return {...super.Request, organizationId};
    }

    Get() {
        return this.SendRequest(BaseSearchableService.GET, this.request);
    }

    GetPermit(permitId) {
        return this.SendRequest(BaseSearchableService.GET, permitId);
    }

    GetPermitsForContext(contextNodeId) {
        return this.SendRequest(BaseSearchableService.GET, {contextNodeId});
    }

    CreatePermit(permit) {
        this.FlushCache();
        return this.SendRequest(BaseSearchableService.POST, permit);
    }

    UpdatePermit(permit) {
        this.FlushCache();
        return this.SendRequest(BaseSearchableService.PUT, permit);
    }
}

export const service = new PermitService();

